<script>
import Layout from "../../layouts/main";
import InfluencerCard from "../../../components/influencerCard";
import SocialCard from "../../../components/socialCard";

import axios from "axios";
import {getCountryFlag, getCountryName, slugify} from "@/state/helpers";
import CalendarCard from "@/components/calendarCard";

const currencySymbolMap = {
  'EUR': '&euro;',
  'RSD': 'RSD',
  'IC': 'IC',
}

/**
 * Saas Dashboard Component
 */
export default {
  components: {CalendarCard, SocialCard, Layout, InfluencerCard},
  data() {
    return {
      influencer: null,
      posts: [],

      expandedPrices: false,
    };
  },
  computed: {
    userType () {
      return this.$store.getters['user/userType'];
    },
    influencerId() {
      return this.$route.params.id;
    },
    malePercentage() {
      return Math.round(this.influencer.male_count * 100 / (this.influencer.female_count + this.influencer.male_count))
    },
    femalePercentage() {
      return Math.round(this.influencer.female_count * 100 / (this.influencer.female_count + this.influencer.male_count));
    },
    audienceByCountries() {
      if (!this.influencer.social_network_accounts.instagram || !this.influencer.social_network_accounts.instagram.demographic_audience) {
        return []
      }
      const countriesByCode = this.influencer.social_network_accounts.instagram.demographic_audience.audience_country
          .reduce((result, item) => {
            result[item['country']] = item;
            return result;
          }, {});

      if (countriesByCode.hasOwnProperty('XK')) {
        countriesByCode['RS'] = {
          country: 'RS',
          value: countriesByCode['RS'].value ?? 0
        }
        countriesByCode['RS'].value = countriesByCode['RS'].value + countriesByCode['XK'].value
        delete countriesByCode['XK']
      }

      const total = Object.values(countriesByCode).reduce((result, item) => {
        return result + item.value
      }, 0)

      return Object.values(countriesByCode)
          .map(audience => {
            audience.percentage = (audience.value * 100 / total).toFixed(1);
            return audience
          })
          .sort((a, b) => b.value - a.value);
    },
    audienceByCities() {
      if (!this.influencer.social_network_accounts.instagram) {
        return []
      }
      const audienceCity = this.influencer.social_network_accounts.instagram.demographic_audience.audience_city;

      const total = audienceCity.reduce((result, item) => {
        return result + item.value
      }, 0)

      return audienceCity
          .map(audience => {
            audience.place = audience.city.split(',')[0]
            audience.percentage = (audience.value * 100 / total).toFixed(1);
            return audience;
          })
          .sort((a, b) => b.value - a.value);
    },
    ageBarChart() {
      if (!this.influencer.social_network_accounts.instagram || !this.influencer.social_network_accounts.instagram.demographic_audience) {
        return null
      }
      const audience = this.influencer.social_network_accounts.instagram.demographic_audience.audience_gender_age
          .reduce((result, item) => {
            if (!['M', 'F'].includes(item.gender) || !result[item.gender].hasOwnProperty(item.age_group)) {
              return result
            }
            result[item.gender][item.age_group] += item.value

            return result;
          }, {
            M: {
              '13-17': 0,
              '18-24': 0,
              '25-34': 0,
              '35-44': 0,
              '45-54': 0,
              '65+': 0
            },
            F: {
              '13-17': 0,
              '18-24': 0,
              '25-34': 0,
              '35-44': 0,
              '45-54': 0,
              '65+': 0
            }
          })

      return {
        series: [{
          name: "Male",
          data: [{
            x: '18-24',
            y: [0, audience.M['18-24']]
          }, {
            x: '25-34',
            y: [0, audience.M['25-34']]
          }, {
            x: '35-44',
            y: [0, audience.M['35-44']]
          }, {
            x: '45+',
            y: [0, audience.M['45-54'] + audience.M['65+']]
          }]
        }, {
          name: "Female",
          data: [{
            x: '18-24',
            y: [0, audience.F['18-24']]
          }, {
            x: '25-34',
            y: [0, audience.F['25-34']]
          }, {
            x: '35-44',
            y: [0, audience.F['35-44']]
          }, {
            x: '45+',
            y: [0, audience.F['45-54'] + audience.F['65+']]
          }]
        }],
        chartOptions: {
          chart: {
            type: 'bar',
            toolbar: {
              show: false
            }
          },
          colors: ['#1C1565', '#00B2CF'],
          plotOptions: {
            bar: {
              horizontal: false
            }
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            x: {
              formatter: (value) => 'Age range ' + value,
            },
          },
        }
      };
    },
    genderDonutChart() {
      if (!this.influencer.social_network_accounts.instagram) {
        return null
      }

      return {
        series: [this.femalePercentage, this.malePercentage],
        chartOptions: {
          tooltip: {
            y: {
              formatter: function (value) {
                return value + '%';
              }
            }
          },
          chart: {
            type: 'donut',
          },
          labels: ['Female', 'Male'],
          colors: ['#00B2CF', '#1C1565'],
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          plotOptions: {
            pie: {
              donut: {
                size: '70%',
                labels: {
                  show: true,
                  name: {
                    show: true,
                    fontSize: '22px',
                    fontFamily: 'sans-serif',
                    fontWeight: 400,
                    offsetY: 10,
                    formatter: function (val) {
                      return val
                    }
                  },
                  value: {
                    show: true,
                    fontSize: '22px',
                    // fontFamily: 'sans-serif',
                    fontWeight: 600,
                    offsetY: -28,
                    formatter: function (val) {
                      return val + '%';
                    }
                  },
                  total: {
                    show: true,
                    showAlways: true,
                    label: 'Total reach',
                    fontSize: '20px',
                    fontFamily: 'sans-serif',
                    fontWeight: 600,
                    color: '#adb5bd',
                    // eslint-disable-next-line no-unused-vars
                    formatter: function (w) {
                      return this.influencer.social_network_accounts.instagram.followers_count
                    }.bind(this)
                  }
                }
              }
            }
          }
        }
      }
    },
    isNewOnPlatform() {
      const d = new Date();
      d.setDate(d.getDate() - 30);

      return (new Date(this.influencer.created_at)) >= d
    }
  },
  async beforeMount() {
    await this.fetchCurrentInfluencer();
  },
  methods: {
    async fetchCurrentInfluencer() {
      this.$store.commit('loader/START_LOADING');
      try {
        const response = await axios.get(`/${this.userType}/influencer/${this.influencerId}`)
        this.influencer = response.data.influencer

        const recentPosts = response.data.recent_posts ?? [];
        this.posts = recentPosts.map((post) => {
          let metrics = {};
          if ((post.info.social_network === 'instagram' && post.info.post_type === 'FEED') || post.info.social_network === 'facebook') {
            metrics = {
              impressions: post.insights.impressions,
              engagement: post.insights.engagement,
              reach: post.insights.reach
            };
          } else if (post.info.social_network === 'instagram' && post.info.post_type === 'STORY') {
            metrics = {
              impressions: post.insights.impressions,
              replies: post.insights.replies,
              reach: post.insights.reach
            };
          } else if (post.info.social_network === 'youtube') {
            metrics = {
              views: post.insights.views,
              engagement: post.insights.engagement,
              likes: post.insights.likes
            };
          }
          return {
            social_network: post.info.social_network,
            media_url: post.info.media_url,
            username: post.info.username,
            permalink: post.info.permalink,
            metrics
          }
        });
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    sum(pack) {
      return pack.price_package_items.reduce((acc, item) => acc + item.price * item.quantity, 0);
    },
    percentage(pack) {
      let diff = pack.total_gross_price - this.sum(pack);
      let percentage = diff / this.sum(pack) * 100;
      return parseInt(percentage, 10);
    },
    getCurrencySymbol(currency) {
      const upper = currency.toUpperCase();
      if (upper in currencySymbolMap) {
        return currencySymbolMap[upper]
      }
      return currency;
    },
    isSinglePrice(pricePackage) {
      return pricePackage.price_package_items.length === 1 && pricePackage.price_package_items[0].quantity <= 1;
    },
    getCountryName: getCountryName,
    getCountryFlag: getCountryFlag,
    slugify: slugify,
  },
};
</script>

<template>
  <Layout>
    <div v-if="influencer">
      <InfluencerCard v-if="influencer" :influencer="influencer" :key="influencer._id"></InfluencerCard>

      <!--    <AddToCardModal v-if="showAddToCartModal" :price-package="addToCartPricePackage"-->
      <!--                    @closed="showAddToCartModal = false"></AddToCardModal>-->

      <div class="row">
        <div class="col-6">
          <div class="">
            <CalendarCard v-if="influencer" :influencer="influencer"></CalendarCard>
          </div>
        </div>
        <div class="col-6 d-flex">
          <div class="row">
            <div class="col-4 d-flex">
              <div class="card flex-fill">
                <div class="card-body">
                  <div class="mb-3 d-flex justify-content-between">
                    <div>
                      <div class="avatar-xs mr-3 mb-1">
                      <span
                          class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                      >
                        <i class="fas fa-camera"></i>
                      </span>
                      </div>
                      <h5 class="font-size-14 mb-0">Post Frequency</h5>
                    </div>
                    <div>
                      <i class="ml-1 fas fa-info-circle"
                         v-b-tooltip.hover
                         title="The average number of posts the user publishes per week. Calculated on 3 months period."></i>
                    </div>

                  </div>
                  <div class="text-muted mt-4">
                    <div v-if="influencer.instagram_post_frequency != null">
                      <h4 class="d-inline-block">{{ influencer.instagram_post_frequency.toLocaleString() }}</h4> <span
                        class="text-truncate">/week</span>
                    </div>
                    <div v-else>
                      <h4 class="d-inline-block">N/A</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-4 d-flex">
              <div class="card flex-fill">
                <div class="card-body">
                  <div class="mb-3 d-flex justify-content-between">
                    <div>
                      <div class="avatar-xs mr-3 mb-1">
                      <span
                          class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                      >
                        <i class="fas fa-arrow-circle-up"></i>
                      </span>
                      </div>
                      <h5 class="font-size-14 mb-0">Audience Growth Rate</h5>
                      <span class="font-size-11" v-if="isNewOnPlatform"><i
                          class="fas fa-exclamation-triangle text-warning"></i> The user has been on the platform for less than a month.</span>
                    </div>
                    <div>
                      <i class="ml-1 fas fa-info-circle"
                         v-b-tooltip.hover
                         title="The rate of growth for influencer's Instagram followers, for the last 30 days."></i>

                    </div>
                  </div>
                  <div class="text-muted mt-4">
                    <div v-if="influencer.instagram_audience_growth_rate != null">
                      <h4 class="d-inline-block">{{ influencer.instagram_audience_growth_rate.toLocaleString() }}</h4>
                      <span class="text-truncate">%</span>
                    </div>
                    <div v-else>
                      <h4 class="d-inline-block">N/A</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-4 d-flex">
              <div class="card flex-fill">
                <div class="card-body">
                  <div class="mb-3 d-flex justify-content-between">
                    <div>
                      <div class="avatar-xs mr-3 mb-1">
                      <span
                          class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                        <i class="fas fa-ad"></i>
                      </span>
                      </div>
                      <h5 class="font-size-14 mb-0">Advertising Post Frequency</h5>
                      <span class="font-size-11" v-if="isNewOnPlatform"><i
                          class="fas fa-exclamation-triangle text-warning"></i> The user has been on the platform for less than a month.</span>
                    </div>
                    <div>
                      <i class="ml-1 fas fa-info-circle"
                         v-b-tooltip.hover
                         title="The average number of advertising posts the user publishes per month. Calculated on 3 months period."></i>
                    </div>
                  </div>
                  <div class="text-muted mt-4">
                    <div v-if="influencer.instagram_advertising_post_frequency != null">
                      <h4 class="d-inline-block">{{
                          influencer.instagram_advertising_post_frequency.toLocaleString()
                        }}</h4> <span class="text-truncate">/month</span>
                    </div>
                    <div v-else>
                      <h4 class="d-inline-block">N/A</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 d-flex" v-if="influencer.delivery_city">
              <div class="card flex-fill">
                <div class="card-body">
                  <div class="row">
                    <dt class="col-sm-5">Name</dt>
                    <dd class="col-sm-7">{{ influencer.name }}</dd>

                    <dt class="col-sm-5">Email</dt>
                    <dd class="col-sm-7">{{ influencer.email }}</dd>

                    <dt class="col-sm-5">Phone</dt>
                    <dd class="col-sm-7">{{ influencer.phone_number }}</dd>

                    <dt class="col-sm-5">Birth</dt>
                    <dd class="col-sm-7">{{ influencer.date_of_birth | serbianDateFormat }}</dd>

                    <dt class="col-sm-5">Gender</dt>
                    <dd class="col-sm-7 text-capitalize">{{ influencer.gender }}</dd>

                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 d-flex" v-if="influencer.delivery_city">
              <div class="card ">
                <div class="card-body">
                  <div class="row">
                    <dt class="col-sm-5">Delivery city</dt>
                    <dd class="col-sm-7">{{ influencer.delivery_city }}</dd>

                    <dt class="col-sm-5">Delivery contact person</dt>
                    <dd class="col-sm-7">{{ influencer.delivery_contact_person }}</dd>

                    <dt class="col-sm-5">Delivery phone number</dt>
                    <dd class="col-sm-7">{{ influencer.delivery_phone_number }}</dd>

                    <dt class="col-sm-5">Delivery postal code</dt>
                    <dd class="col-sm-7">{{ influencer.delivery_postal_code }}</dd>

                    <dt class="col-sm-5">Delivery street address</dt>
                    <dd class="col-sm-7">{{ influencer.delivery_street_address }}</dd>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-4" style="margin-bottom: 24px">
          <div class="card h-100">
            <div class="card-body">
              <h4 class="card-title mb-4">Instagram Audience Analytics</h4>
              <div class="row d-flex" v-if="audienceByCountries.length > 0">
                <div class="col-md-12 mb-3 border-line">
                  <h5>Country</h5>
                  <div>
                    <table class="font-size-16 " style="">
                      <tr v-for="(audience, index) in audienceByCountries.slice(0, 7)" :key="audience.country"
                          class="mb-1">
                        <td class="text-right pr-2">{{ index + 1 }}.</td>
                        <td class="pr-2">
                          <img :src="getCountryFlag(audience.country)" class="flag-image" style=" height: 15px;" :alt="audience.country">
                        </td>
                        <td class="pr-2 ">{{ audience.percentage }}%</td>
                        <td class="">{{ getCountryName(audience.country) }}</td>
                      </tr>
                    </table>

                    <!--              <div class="col-xl-5 col-sm-12">-->
                    <!--                <h5>City</h5>-->
                    <!--                <table class="font-size-16">-->
                    <!--                  <tr v-for="(audience) in audienceByCities.slice(0, 5)" :key="audience.place" class="mb-1">-->
                    <!--                    <td class="pr-2  text-muted">{{ (audience.percentage) }}%</td>-->
                    <!--                    <td class="pr-2">{{ audience.place }}</td>-->
                    <!--                  </tr>-->
                    <!--                </table>-->
                    <!--              </div>-->

                  </div>
                </div>
              </div>
              <div v-else>
                <h1>N/A</h1>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-4" style="margin-bottom: 24px">
          <div class="card h-100">
            <div class="card-body">
              <h4 class="card-title mb-4">Instagram Audience Demographics</h4>

              <div v-if="ageBarChart">
                <apexchart
                    class="apex-charts"
                    height="240"
                    type="bar"
                    :series="ageBarChart.series"
                    :options="ageBarChart.chartOptions"
                ></apexchart>
              </div>
              <div v-else>
                <h1>N/A</h1>
              </div>

            </div>
          </div>
        </div>

        <div class="col-xl-4">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Instagram Audience Summary</h4>

              <div v-if="genderDonutChart">
                <div>
                  <apexchart
                      class="apex-charts"
                      dir="ltr"
                      height="240"
                      :series="genderDonutChart.series"
                      :options="genderDonutChart.chartOptions"
                  ></apexchart>
                </div>

                <div class="text-center text-muted">
                  <div class="row">
                    <div class="col-6">
                      <div class="mt-4  d-flex align-items-center justify-content-center">
                        <div class="mr-2">
                          <i style="color: #1C1565" class="fa fa-circle" aria-hidden="true"></i>
                        </div>
                        <div>
                          <p class="mb-2 text-truncate">
                            <i class="bx bx-male-sign"></i>
                            Male
                          </p>
                          <h3>{{ influencer.male_count | compactNumber }}</h3>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mt-4 d-flex align-items-center justify-content-center">
                        <div class="mr-2">
                          <i style="color: #00B2CF" class="fa fa-circle" aria-hidden="true"></i>
                        </div>
                        <div>
                          <p class="mb-2 text-truncate">
                            <i class="bx bx-female-sign"></i>
                            Female
                          </p>
                          <h3>{{ influencer.female_count | compactNumber }}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <h1>N/A</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title  mb-4">{{ $t('Recent posts') }}</h4>
              <div v-if="posts && posts.length > 0" class="row">
                <div class="col-12 col-md-4 col-lg-4 col-xl-3  mb-3" v-for="post in posts" :key="post.media_url">
                  <social-card :post="post"></social-card>
                </div>
              </div>
              <div v-else>
                <h4 class="text-muted text-center  mb-4">
                  {{ $t('No data') }}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>

.price-container {
  width: 170px;
}

.total-price {
  position: relative;
}

.total-badge {
  position: absolute;
  top: -5px;
}

.sum {
  position: relative;
  display: inline-block;
}

.sum:before {
  position: absolute;
  content: "";
  left: 0;
  top: 40%;
  right: 0;
  border-top: 1px solid;
  border-color: inherit;
  -webkit-transform: rotate(-5deg);
  -moz-transform: rotate(-5deg);
  -ms-transform: rotate(-5deg);
  -o-transform: rotate(-5deg);
  transform: rotate(-11deg);
}
</style>
